import { useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { AdminUserAgent } from "../../../../../../../api/adminUserAgent";
import { setSupportEmailError } from "../../../../../../../reducers/error";

const useSupportBoxPopup = ({ onClose }) => {
    const [question, setQuestion] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const error = useSelector((state) => state.errorObserver.supportEmailError);

    const handleClose = () => {
        onClose();
    };

    const handleInputChange = ({ target: { value } }) => setQuestion(value);

    const handleSend = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        dispatch(setSupportEmailError(null)); 
        try {
            const token = window.localStorage.getItem("token");
            await AdminUserAgent.sendEmailToSupport(token, question);
            handleClose();
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Unknown error";
            dispatch(setSupportEmailError(errorMessage));
        } finally {
            setIsLoading(false);
        }
    };

    return { handleSend, handleClose, handleInputChange, question, isLoading, error };
};

export default useSupportBoxPopup;